import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import settingsReducer from './reducer/settingsReducer';


const rootReducer = combineReducers({
  settings: settingsReducer,

});

// const userData = JSON.parse(localStorage.getItem('user'));
// const initialState = {
//   auth: {
//     user: userData,
//     userId: userData ? userData.id : null,
//     error: null,
//     isAuthenticated: !!userData
//   }
// };
const store = createStore(
  rootReducer,
  // initialState,
  applyMiddleware(thunk)
);
export default store;